export default "__VITE_ASSET__Cg1c0Kzh__"